import { useQuery, useMutation } from "./urqlHooks";

const GET_DEBTS_EMAIL_PREVIEW = `
  query getDebtsEmailPreview($previewInput: DebtsEmailPreviewInput!) {
    getDebtsEmailPreview(previewInput: $previewInput) {
      subject
      body
    }
  }
`;

export const GetDebtsEmailPreview = (previewInput) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_DEBTS_EMAIL_PREVIEW,
    variables: { previewInput },
    pause: !previewInput?.companyId || !previewInput?.clientRut || !previewInput?.documentsIds?.length,
    requestPolicy: "network-only",
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_NEW_COBRANZA = `query GetClientsDebtsToPay($companyId: String!){
    getClientsDebtsToPay(companyId:$companyId)
}`;

export const GetCobranza = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_NEW_COBRANZA,
    variables: { companyId },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_NEW_COBRANZA_AS_EXCEL = `mutation getDebtsAsExcel($companyId: String!, $receiverId: String!){
  getDebtsAsExcel(companyId:$companyId, receiverId:$receiverId)
}`;

export const GetCobranzaAsExcel = (companyId) => {
const [result, executeMutation] = useMutation(GET_NEW_COBRANZA_AS_EXCEL);
const { data, fetching, error } = result;
return { data, fetching, error, executeMutation };
};

const GET_CO_TOKEN_BY_COMPANY_ID = `
  query getCOTokenByCompanyId($companyId: String!) {
    getCOTokenByCompanyId(companyId: $companyId)
  }
`;

export const GetCOTokenByCompanyId = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_CO_TOKEN_BY_COMPANY_ID,
    variables: { companyId },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const SEND_DEBTS_COLLECTION_EMAIL = `
  mutation sendDebtsCollectionEmail($debtsEmailInput: DebtsEmailInput!) {
    sendDebtsCollectionEmail(debtsEmailInput: $debtsEmailInput)
  }
`;

export const SendDebtsCollectionEmail = () => {
  const [result, executeMutation] = useMutation(SEND_DEBTS_COLLECTION_EMAIL);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const UPDATE_SELECTED_COBRANZA = ` 
  mutation updateSelectedCobranza($idArray: IdArray!, $selected: Boolean!, $companyId: String!){
    updateSelectedCobranza(idArray: $idArray, selected: $selected, companyId: $companyId)
  }
`;

export const UpdateSelectedCobranza = () => {
  const [result, executeMutation] = useMutation(UPDATE_SELECTED_COBRANZA);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};


const CREATE_CO_DEBTS = ` 
  mutation createCODebts($coDebtInput:CODebtInput!, $companyId:String!, $idArray: IdArray!){
    createCODebts(coDebtInput:$coDebtInput, companyId:$companyId, idArray: $idArray){
      id
      valid
      status
    }
  }
`;

export const CreateCODebts = () => {
  const [result, executeMutation] = useMutation(CREATE_CO_DEBTS);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const GET_CREATED_CO_COLLECTIONS_BY_COMPANY = `
  query getCreatedCOCollectionsByCompany($companyId: String!) {
    getCreatedCOCollectionsByCompany(companyId: $companyId)
  }
`;

export const GetCreatedCOCollectionsByCompany = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_CREATED_CO_COLLECTIONS_BY_COMPANY,
    variables: { companyId },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_CLIENT_DEBTS_CO_COMISSION = `
  mutation getClientDebtsCOComission($input: COClientsDebtsComissionInput!, $companyId: String!) {
    getClientDebtsCOComission(input: $input, companyId: $companyId){
      rut
      debts{
          id
          comission
      }
  }
  }
`;

export const GetClientDebtsCOComission = () => {
  const [result, executeMutation] = useMutation(GET_CLIENT_DEBTS_CO_COMISSION);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const ADD_NOTIFICATION_COBRANZA = `
  mutation addNotificationCobranza(
    $userEmail:String!,
    $userId: String!,
    $agendaId: String!,
    $companyId: String!,
){
  addNotificationCobranza(
    userEmail: $userEmail,
    userId: $userId,
    agendaId: $agendaId,
    companyId:$companyId
  ){
    ok
    nModified
  }
}
`;

export const AddNotificationCobranza = () => {
  const [result, executeMutation] = useMutation(ADD_NOTIFICATION_COBRANZA);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const CREATE_COBRANZA_CLIENT_COMMENT = `
  mutation createCobranzaClientComment($agendaId: String!, $input: AgendaCollectionCommentInput!, $companyId: String!) {
    createCobranzaClientComment(agendaId: $agendaId, input: $input, companyId: $companyId) {
      id
    }
  }
`;

export const CreateCobranzaClientComment = () => {
  const [result, executeMutation] = useMutation(CREATE_COBRANZA_CLIENT_COMMENT);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const UPDATE_COBRANZA_CLIENT_COMMENT = `
  mutation updateCobranzaClientComment($agendaId: String!, $noteIndex: Float!, $comment: String!, $companyId: String!) {
    updateCobranzaClientComment(agendaId: $agendaId, noteIndex: $noteIndex, comment: $comment, companyId: $companyId) {
      id
    }
  }
`;

export const UpdateCobranzaClientComment = () => {
  const [result, executeMutation] = useMutation(UPDATE_COBRANZA_CLIENT_COMMENT);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const REMOVE_COBRANZA_CLIENT_COMMENT = `
  mutation removeCobranzaClientComment($agendaId: String!, $noteIndex: Float!, $companyId: String!) {
    removeCobranzaClientComment(agendaId: $agendaId, noteIndex: $noteIndex, companyId: $companyId) {
      id
    }
  }
`;

export const RemoveCobranzaClientComment = () => {
  const [result, executeMutation] = useMutation(REMOVE_COBRANZA_CLIENT_COMMENT);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const SET_PINNED_COBRANZA_CLIENT_COMMENT = `
  mutation setPinnedCobranzaClientComment($agendaId: String!, $noteIndex: Float!, $isPinned: Boolean!, $companyId: String!) {
    setPinnedCobranzaClientComment(agendaId: $agendaId, noteIndex: $noteIndex, isPinned: $isPinned, companyId: $companyId) {
      id
    }
  }
`;

export const SetPinnedCobranzaClientComment = () => {
  const [result, executeMutation] = useMutation(SET_PINNED_COBRANZA_CLIENT_COMMENT);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

// Nota: el backend puede devolver String (JSON) o un objeto tipado.
// Para máxima compatibilidad, pedimos el campo como escalar y lo parseamos en cliente.
const GET_COLLECTION_REPORT = `
query GET_COLLECTION_REPORT($companyId: String, $companyIds: [String!], $start: String, $end: String, $excludeIntercompany: Boolean) {
  getCollectionReport(companyId: $companyId, companyIds: $companyIds, start: $start, end: $end, excludeIntercompany: $excludeIntercompany)
}`;

const GET_COMPANY_BANK_DETAILS_FOR_COBRANZA = `
  query getCompanyBankDetailsForCobranza($companyId: String!) {
    getCompanyBankDetailsForCobranza(companyId: $companyId) {
      companyName
      companyRut
      accounts {
        id
        bankName
        accountNumber
        currency
        rut
        accountType
        email
        holderName
      }
    }
  }
`;

export const GetCompanyBankDetailsForCobranza = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_COMPANY_BANK_DETAILS_FOR_COBRANZA,
    variables: { companyId },
    pause: !companyId,
    requestPolicy: "cache-first",
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_BANKS_FOR_COBRANZA = `
  query getBanksForCobranza {
    getBanksForCobranza {
      id
      name
    }
  }
`;

export const GetBanksForCobranza = () => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_BANKS_FOR_COBRANZA,
    requestPolicy: "cache-first",
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const ADD_COBRANZA_BANK_ACCOUNT = `
  mutation addCobranzaBankAccount($companyId: String!, $input: CobranzaBankAccountInput!) {
    addCobranzaBankAccount(companyId: $companyId, input: $input) {
      id
      companyId
      bankId
      accountNumber
      currency
    }
  }
`;

export const AddCobranzaBankAccount = () => {
  const [result, executeMutation] = useMutation(ADD_COBRANZA_BANK_ACCOUNT);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const UPDATE_COBRANZA_BANK_ACCOUNT = `
  mutation updateCobranzaBankAccount($accountId: String!, $input: CobranzaBankAccountInput!, $companyId: String!) {
    updateCobranzaBankAccount(accountId: $accountId, input: $input, companyId: $companyId) {
      id
      companyId
      bankId
      accountNumber
      currency
    }
  }
`;

export const UpdateCobranzaBankAccount = () => {
  const [result, executeMutation] = useMutation(UPDATE_COBRANZA_BANK_ACCOUNT);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const DELETE_COBRANZA_BANK_ACCOUNT = `
  mutation deleteCobranzaBankAccount($companyId: String!, $accountId: String!) {
    deleteCobranzaBankAccount(companyId: $companyId, accountId: $accountId)
  }
`;

const GET_COBRANZA_PLANTILLAS = `
  query getCobranzaPlantillas($companyId: String!, $plantillaTipo: String) {
    getCobranzaPlantillas(companyId: $companyId, plantillaTipo: $plantillaTipo) {
      id
      nombre
      frecuencia
      diaMes
      contraparteEmails
      cuentaBancariaId
      contenidoHtml
      envioAutomaticoActivo
      plantillaTipo
      asuntoPlantilla
    }
  }
`;

const SAVE_COBRANZA_PLANTILLAS = `
  mutation saveCobranzaPlantillas($companyId: String!, $plantillas: [CobranzaPlantillaInput!]!) {
    saveCobranzaPlantillas(companyId: $companyId, plantillas: $plantillas) {
      id
      nombre
      frecuencia
      diaMes
      contraparteEmails
      cuentaBancariaId
      contenidoHtml
      envioAutomaticoActivo
      plantillaTipo
      asuntoPlantilla
    }
  }
`;

const DELETE_COBRANZA_PLANTILLA = `
  mutation deleteCobranzaPlantilla($companyId: String!, $plantillaId: String!) {
    deleteCobranzaPlantilla(companyId: $companyId, plantillaId: $plantillaId)
  }
`;

export const GetCobranzaPlantillas = (companyId, plantillaTipo = "automation") => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_COBRANZA_PLANTILLAS,
    variables: { companyId, plantillaTipo: plantillaTipo || undefined },
    pause: !companyId,
    requestPolicy: "cache-first",
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

export const SaveCobranzaPlantillas = () => {
  const [result, executeMutation] = useMutation(SAVE_COBRANZA_PLANTILLAS);
  return { ...result, executeMutation };
};

export const DeleteCobranzaPlantilla = () => {
  const [result, executeMutation] = useMutation(DELETE_COBRANZA_PLANTILLA);
  return { ...result, executeMutation };
};

export const DeleteCobranzaBankAccount = () => {
  const [result, executeMutation] = useMutation(DELETE_COBRANZA_BANK_ACCOUNT);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const GET_COLLECTION_PAID_INVOICE_HISTORY = `
  query getCollectionPaidInvoiceHistory(
    $companyId: String!
    $receiverRut: String!
    $limit: Int
    $offset: Int
  ) {
    getCollectionPaidInvoiceHistory(
      companyId: $companyId
      receiverRut: $receiverRut
      limit: $limit
      offset: $offset
    ) {
      totalCount
      avgDso
      items {
        id
        documentId
        folio
        documentCode
        documentLabel
        dueDate
        paymentDate
        originalAmount
        dsoDays
      }
    }
  }
`;

const REFRESH_COLLECTION_DSO = `
  mutation refreshCollectionDso($companyId: String!) {
    refreshCollectionDso(companyId: $companyId) {
      companyId
      updatedAgendasCount
      clientsWithHistoryCount
      refreshedAt
    }
  }
`;

export const RefreshCollectionDso = () => {
  const [result, executeMutation] = useMutation(REFRESH_COLLECTION_DSO);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

export const GetCollectionPaidInvoiceHistory = ({
  companyId,
  receiverRut,
  limit = 100,
  offset = 0,
}) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_COLLECTION_PAID_INVOICE_HISTORY,
    variables: { companyId, receiverRut, limit, offset },
    pause: !companyId || !receiverRut,
    requestPolicy: "network-only",
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

export const GetCollectionReport = ({ companyId, companyIds, start, end, excludeIntercompany = false }) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_COLLECTION_REPORT,
    variables: { companyId, companyIds, start, end, excludeIntercompany },
    pause: (!(Array.isArray(companyIds) && companyIds.length > 0) && !companyId) || !start || !end,
    requestPolicy: 'cache-and-network',
  });

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

// Query para obtener los documentos de un proveedor específico
const GET_COLLECTION_DOCUMENTS = `
query GET_COLLECTION_DOCUMENTS($companyId: String!, $rut: String, $pagination: PaginationInput, $filter: TaxDocumentFilter) {
  paginatedTaxDocumentsByCompany(
    companyId: $companyId
    rut: $rut
    detalle: false
    filter: $filter
    pagination: $pagination
  ) {
    count
    documents {
      _id
      meta {
        id
        documentId
        documentCode
        folio
        remaining
        netAmount
        originalAmount
        issuerName
        issuerRut
        issuedAt
        isValid
        isReceived
      }
      dueDate
      originalDueDate
      documentDate
    }
  }
}`;

export const GetCollectionDocuments = ({ companyId, rut, pagination }) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_COLLECTION_DOCUMENTS,
    variables: { 
      companyId, 
      rut,
      filter: {
        isValid: true,
        isReceived: false
      },
      pagination: pagination || { page: 1, limit: 100 }
    },
    pause: !companyId || !rut,
    // requestPolicy: 'cache-first',
  });

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

// Query para exportar el reporte de cobranza a Excel
const EXPORT_COLLECTION_REPORT_TO_EXCEL = `
query EXPORT_COLLECTION_REPORT_TO_EXCEL($companyId: String, $companyIds: [String!], $start: String, $end: String, $language: String) {
  exportCollectionReportToExcel(companyId: $companyId, companyIds: $companyIds, start: $start, end: $end, language: $language)
}`;

export const ExportCollectionReportToExcel = ({ companyId, companyIds, start, end, language }) => {
  const [result, reexecuteQuery] = useQuery({
    query: EXPORT_COLLECTION_REPORT_TO_EXCEL,
    variables: { companyId, companyIds, start, end, language },
    pause: true, // Pausado por defecto, se ejecutará manualmente
    requestPolicy: 'network-only',
  });

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const EXPORT_COBRANZA_MODULE_REPORT_TO_EXCEL = `
query EXPORT_COBRANZA_MODULE_REPORT_TO_EXCEL($companyId: String!, $start: String, $end: String) {
  exportCobranzaModuleReportToExcel(companyId: $companyId, start: $start, end: $end)
}`;

export const ExportCobranzaModuleReportToExcel = ({ companyId, start, end }) => {
  const [result, reexecuteQuery] = useQuery({
    query: EXPORT_COBRANZA_MODULE_REPORT_TO_EXCEL,
    variables: { companyId, start, end },
    pause: true,
    requestPolicy: 'network-only',
  });

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};